import AbstractFilter from './AbstractFilter';

export default class AddProtocol extends AbstractFilter
{
    protected protocol = 'http';

    filter(value: any): string
    {
        let link = value.toString();

        if (link.length > 0 && !link.match(/^(\w+:)?\/\//))
        {
            link = (this._options && this._options.protocol ? this._options.protocol : this.protocol) + '://' + link;
        }

        return link;
    }
}